import { ReportFileViewerPage } from '@/features/reports/report-file-viewer-page';

const AccountCleanupViewerPage = () => <ReportFileViewerPage backLabel="Back to Account Cleanup" backTo="/operations/user-audit/cleanup" />;
AccountCleanupViewerPage.displayName = 'AccountCleanupViewerPage';

export default AccountCleanupViewerPage;
